// Core Modules
import { Pipe, PipeTransform } from '@angular/core';

// External Modules
import { marked } from 'marked';

/**
 * Renders a Markdown string (GitHub-flavored: tables, bold, lists) to an HTML
 * string. Bind the result through `[innerHTML]`, which applies Angular's
 * built-in HTML sanitizer — do not bypass it for untrusted/model-generated text.
 */
@Pipe({
  name: 'markdown',
  standalone: true,
  pure: true,
})
export class MarkdownPipe implements PipeTransform {
  public transform(value: string | null | undefined): string {
    if (!value) return '';
    return marked.parse(value, { async: false, gfm: true, breaks: true }) as string;
  }
}
